import { fg } from '@atlaskit/platform-feature-flags';

import { isStaging } from '../env-helpers';

const STUDIO_PROD_URL = 'https://studio.atlassian.com';
const STUDIO_STAGING_URL = 'https://atlassian-studio.stg-east.frontend.public.atl-paas.net';

export const getStudioHost = (): string => {
	return isStaging() ? STUDIO_STAGING_URL : STUDIO_PROD_URL;
};

export const getStudioPath = (path: string) =>
	fg('redirect_to_new_studio_app') ? `${getStudioHost()}${path}` : `/studio${path}`;

export const getAtlassianStudioAgentCreateUrl = (siteId: string) => {
	return getStudioPath(`/s/${siteId}/agents/create/overview`);
};

export const getAtlassianStudioRedirectBaseUrl = (siteId: string, agentId: string) =>
	getStudioPath(`/s/${siteId}/agents/enrich/rovo/agents/${agentId}`);

export const getAtlassianStudioAgentEditUrl = (siteId: string, agentId: string) =>
	getStudioPath(
		`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?redirect=${encodeURIComponent('/:agentId/overview')}`,
	);

export const getAtlassianStudioAgentDuplicateUrl = (siteId: string, agentId: string) =>
	getStudioPath(
		`/s/${siteId}/agents/enrich/rovo/agents/${agentId}?redirect=${encodeURIComponent('/create')}`,
	);
